import { defineStore } from "pinia";
import axios from "axios";
import { useToast } from 'vue-toastification';
const toast = useToast();


export const useTradeStore = defineStore("trade", {
    state: () => {
        return {
            tps: 0,
            sls: 0,
            datas: [],
            totals: 0,
            historyStatuss: 'open',
            loadings: true,
            showAlls: true
        };
    },

    getters: {
        tp: (state) => state.tps,
        sl: (state) => state.sls,
        data: (state) => state.datas,
        total: (state) => state.totals,
        showAll: (state) => state.showAlls,
        historyStatus: (state) => state.historyStatuss,
        loading: (state) => state.loadings,
    },

    actions: {
        get(params) {
            this.loadings = true;
            this.datas = []
            const config = {
                method: "get",
                url: params.status == 'orderhistory' ? useRuntimeConfig().public.apiBase + 'trade/order/history' : useRuntimeConfig().public.apiBase + 'trade',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ...params
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        this.datas = res.data.data.trades
                        this.totals = res.data.data.count
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        getAll(params) {
            const config = {
                method: "get",
                url: params.status == 'orderhistory' ? useRuntimeConfig().public.apiBase + 'trade/order/history' : useRuntimeConfig().public.apiBase + 'trade',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ...params
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        resolve(res.data.data.trades);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        reject(error.response.data);
                    });
            });
        },
        closeLimit(params) {
            this.loadings = true;
            const config = {
                method: "delete",
                url: useRuntimeConfig().public.apiBase + 'trade/limit/close',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ...params
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false

                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false

                        reject(error.response.data);
                    });
            });
        },
        closeAllLimit(id) {
            this.loadings = true;
            const config = {
                method: "delete",
                url: useRuntimeConfig().public.apiBase + 'trade/limit/close/all',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false

                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false

                        reject(error.response.data);
                    });
            });
        },
        closePosition(params) {
            this.loadings = true;
            const config = {
                method: "delete",
                url: useRuntimeConfig().public.apiBase + 'trade/close',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    ...params
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data);
                    });
            });
        },
        closeAllPosition(id) {
            this.loadings = true;
            const config = {
                method: "delete",
                url: useRuntimeConfig().public.apiBase + 'trade/close/all',
                headers: {
                    usertoken: localStorage.token,
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false

                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false

                        reject(error.response.data);
                    });
            });
        },
        marketBuy(data, id) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'trade/market/buy',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        toast.error(error.response.data.msg);
                        reject(error.response.data.msg);
                    });
            });
        },
        marketSell(data, id) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'trade/market/sell',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        this.loadings = false
                        reject(error.response.data.msg);
                    });
            });
        },
        limitBuy(data, id) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'trade/limit/buy',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        this.loadings = false
                        reject(error.response.data.msg);
                    });
            });
        },
        limitSell(data, id) {
            this.loadings = true;
            const config = {
                method: "post",
                url: useRuntimeConfig().public.apiBase + 'trade/limit/sell',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        if (error.response.status == 402)
                            localStorage.clear()
                        toast.error(error.response.data.msg);
                        this.loadings = false
                        reject(error.response.data.msg);
                    });
            });
        },
        postTp(data, id) {
            this.loadings = true;
            const config = {
                method: "patch",
                url: useRuntimeConfig().public.apiBase + 'trade/tp',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        toast.error(error.response.data.msg);
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        postSl(data, id) {
            this.loadings = true;
            const config = {
                method: "patch",
                url: useRuntimeConfig().public.apiBase + 'trade/sl',
                headers: {
                    usertoken: localStorage.token,
                },
                data: {
                    ...data
                },
                params: {
                    dashboardid: id
                }
            };
            return new Promise((resolve, reject) => {
                axios(config)
                    .then((res) => {
                        this.loadings = false
                        toast.success(res.data.msg);
                        resolve(res);
                    })
                    .catch((error) => {
                        toast.error(error.response.data.msg);
                        if (error.response.status == 402)
                            localStorage.clear()
                        this.loadings = false
                        reject(error.response.data);
                    });
            });
        },
        clearData() {
            this.datas = []
        }
    },
});